module.exports = __webpack_public_path__ + "static/media/003.e12ce9d0.m4v";